// extracted by mini-css-extract-plugin
export default {"productGallery":"xF-z","inQuickShop":"yF-z"};